module.exports = __webpack_public_path__ + "static/media/medioelipse.0f3fd89e.png";